<template>
    <div class="uk-container uk-container-expand report-builder">
        <div class="uk-form-label standard-text primary-color uk-text-uppercase">Report Type</div>
        <select class="uk-select uk-width-auto" v-model="reportType">
            <option value="">-- Select Report Type --</option>
            <option v-for="val in reportTypes" :value="val.type" >{{val.display}}</option>
        </select>
        <!-- Employee Report options -->
        <div class="uk-form uk-margin-medium-top" v-if="reportType == 'employee'">
            <div class="uk-form-label standard-text primary-color">Report Criteria</div>
            <div class="uk-margin-small">
                <label>
                    <input type="checkbox" class="uk-checkbox" v-model="reportData.useBusinessUnits">
                    In Business Unit
                </label>
                <select id="rep_bu" class="uk-select uk-width-auto" :disabled="!reportData.useBusinessUnits" v-model="reportData.businessUnit">
                    <option value="">-- Select Business Unit --</option>
                    <option :value="0">None (Not in a Business Unit)</option>
                    <option v-for="bu in businessUnits" :value="bu.id">{{ bu.name }}</option>
                </select>
            </div>
            <div class="uk-margin-small">
                <label>
                    <input type="checkbox" class="uk-checkbox" v-model="reportData.useRatings">
                    Ratings
                </label>
                Min
                <input type="number" class="uk-input uk-display-inline-block uk-width-auto" v-model="reportData.minRating" min="0" max="5" :disabled="!reportData.useRatings" />
                Max
                <input type="number" class="uk-input uk-display-inline-block uk-width-auto" v-model="reportData.maxRating" min="0" max="5" :disabled="!reportData.useRatings" />
            </div>
            <div class="uk-margin-small">
                <label>
                    <input type="checkbox" class="uk-checkbox" v-model="reportData.useLocation">
                    Location
                </label>
                <select id="rep_state" class="uk-select uk-width-auto" :disabled="!reportData.useLocation" v-model="reportData.state">
                    <option value="">-- Select State --</option>
                    <option v-for="(name, code) in states" :value="code">{{ name }}</option>
                </select>
            </div>
            <div class="uk-margin-small">
                <label>
                    <input type="checkbox" class="uk-checkbox" v-model="reportData.useCrafts">
                    Craft
                </label>
                <select id="rep_craft" class="uk-select uk-width-auto" :disabled="!reportData.useCrafts" v-model="reportData.craft">
                    <option value="">-- Select Craft --</option>
                    <option v-for="craft in crafts" :value="craft.id">{{ craft.name }}</option>
                </select>
            </div>
            <div class="uk-margin-small">
                <label>
                    <input type="checkbox" class="uk-checkbox" v-model="reportData.useCertifications">
                    Certification
                </label>
                <select id="rep_certification" class="uk-select uk-width-auto" :disabled="!reportData.useCertifications" v-model="reportData.certification">
                    <option value="">-- Select Certification --</option>
                    <option v-for="cert in certifications" :value="cert.id">{{ cert.name }}</option>
                </select>
				<datepicker ref="cert_expire_date" placeholder="Does not expire before" @input="certExpireUpdated" :value="reportData.certExpireDate" wrapper-class="inline" input-class="uk-input" :disabled="!reportData.useCertifications" :use-utc=true :clear-button=true :typeable=true clear-button-icon="fa fa-times" format="MM/dd/yyyy"></datepicker>
            </div>
            <div class="uk-margin-small">
                <label>
                    <input type="checkbox" class="uk-checkbox" v-model="reportData.useTraining">
                    Training
                </label>
                <select id="rep_training" class="uk-select uk-width-auto" :disabled="!reportData.useTraining" v-model="reportData.training">
                    <option value="">-- Select Training --</option>
                    <option v-for="train in trainings" :value="train.id">{{ train.name }}</option>
                </select>
				<datepicker ref="train_expire_date" placeholder="Does not expire before" @input="trainExpireUpdated" :value="reportData.trainExpireDate" wrapper-class="inline" input-class="uk-input" :disabled="!reportData.useTraining" :use-utc=true :clear-button=true :typeable=true clear-button-icon="fa fa-times" format="MM/dd/yyyy"></datepicker>
            </div>
            <div class="uk-margin-small">
                <label>
                    <input type="checkbox" class="uk-checkbox" v-model="reportData.useActive">
                    That are:
                </label>
                <label :disabled="!reportData.useActive">
                    <input type="radio" name="activity" value="active" v-model="reportData.activity" :disabled="!reportData.useActive" />
                    Active
                </label>
                <label :disabled="!reportData.useActive">
                    <input type="radio" name="activity" value="inactive" v-model="reportData.activity" :disabled="!reportData.useActive" />
                    Inactive
                </label>
            </div>
            <div class="uk-margin-small">
                <label>
                    <input type="checkbox" class="uk-checkbox" v-model="reportData.useExpiring">
                    Training or certification about to expire
                </label>
            </div>
            <div class="uk-margin-small">
                <label>
                    <input type="checkbox" class="uk-checkbox" v-model="reportData.useDNH">
                    For rehire:
                </label>
                <label :disabled="!reportData.useDNH">
                    <input type="radio" name="hireable" value="yes" v-model="reportData.hireable" :disabled="!reportData.useDNH" />
                    Available
                </label>
                <label :disabled="!reportData.useDNH">
                    <input type="radio" name="hireable" value="no" v-model="reportData.hireable" :disabled="!reportData.useDNH" />
                    Unavailable
                </label>
            </div>
            <div class="uk-margin-small">
                <label>
                    <input type="checkbox" class="uk-checkbox" v-model="reportData.useProbation">
                    Probation
                </label>
                <label :disabled="!reportData.useProbation">
                    <input type="radio" name="probation" value="off" v-model="reportData.probation" :disabled="!reportData.useProbation" />
                    Off
                </label>
                <label :disabled="!reportData.useProbation">
                    <input type="radio" name="probation" value="on" v-model="reportData.probation" :disabled="!reportData.useProbation" />
                    On
                </label>
            </div>
            <div class="uk-margin-small">
                <label>
                    <input type="checkbox" class="uk-checkbox" v-model="reportData.useEverify">
                    E-verified
                </label>
            </div>

            <div class="uk-margin-small">
                <label>
                    <input type="checkbox" class="uk-checkbox" v-model="reportData.useDrugTest">
                    Drug Test Status
                </label>
                <label :disabled="!reportData.useDrugTest">
                    <input type="radio" name="drug_test_status" value="completed" v-model="reportData.drugTestStatus" :disabled="!reportData.useDrugTest" />
                    Completed
                </label>
                <label :disabled="!reportData.useDrugTest">
                    <input type="radio" name="drug_test_status" value="pending" v-model="reportData.drugTestStatus" :disabled="!reportData.useDrugTest" />
                    Pending
                </label>
            </div>
        </div>

        <!-- Requisition Report options -->
        <div class="uk-form uk-margin-medium-top" v-if="reportType == 'requisition'">
            <div class="uk-form-label standard-text primary-color">Report Criteria</div>
            <div class="uk-margin-small">
                <label>
                    <input type="checkbox" class="uk-checkbox" v-model="reportData.useBusinessUnits">
                    In Business Unit
                </label>
                <select id="rep_bur" class="uk-select uk-width-auto" :disabled="!reportData.useBusinessUnits" v-model="reportData.businessUnit">
                    <option value="">-- Select Business Unit --</option>
                    <option v-for="bu in businessUnits" :value="bu.id">{{ bu.name }}</option>
                </select>
            </div>
            <div class="uk-margin-small">
                <label>
                    <input type="checkbox" class="uk-checkbox" v-model="reportData.useLocation">
                    Location
                </label>
                <select id="rep_stater" class="uk-select uk-width-auto" :disabled="!reportData.useLocation" v-model="reportData.state">
                    <option value="">-- Select State --</option>
                    <option v-for="(name, code) in states" :value="code">{{ name }}</option>
                </select>
            </div>
            <div class="uk-margin-small">
                <label>
                    <input type="checkbox" class="uk-checkbox" v-model="reportData.useStartDateRange">
                    Starting between:
                </label>
                <datepicker ref="start_start_date" placeholder="Start Date" @input="startStartUpdated" :value="reportData.startStartDate" wrapper-class="inline" input-class="uk-input" :disabled="!reportData.useStartDateRange" :use-utc=true :clear-button=true :typeable=true clear-button-icon="fa fa-times" format="MM/dd/yyyy"></datepicker>
                <datepicker ref="start_end_date" placeholder="End Date" @input="startEndUpdated" :value="reportData.startEndDate" wrapper-class="inline" input-class="uk-input" :disabled="!reportData.useStartDateRange" :use-utc=true :clear-button=true :typeable=true clear-button-icon="fa fa-times" format="MM/dd/yyyy"></datepicker>
            </div>
            <div class="uk-margin-small">
                <label>
                    <input type="checkbox" class="uk-checkbox" v-model="reportData.useEndDateRange">
                    Ending between:
                </label>
                <datepicker ref="end_start_date" placeholder="Start Date" @input="endStartUpdated" :value="reportData.endStartDate" wrapper-class="inline" input-class="uk-input" :disabled="!reportData.useEndDateRange" :use-utc=true :clear-button=true :typeable=true clear-button-icon="fa fa-times" format="MM/dd/yyyy"></datepicker>
                <datepicker ref="end_end_date" placeholder="End Date" @input="endEndUpdated" :value="reportData.endEndDate" wrapper-class="inline" input-class="uk-input" :disabled="!reportData.useEndDateRange" :use-utc=true :clear-button=true :typeable=true clear-button-icon="fa fa-times" format="MM/dd/yyyy"></datepicker>
            </div>
            <div class="uk-margin-small">
                <label>
                    <input type="checkbox" class="uk-checkbox" v-model="reportData.useArchived">
                    Include Archived
                </label>
            </div>
        </div>
	    <!-- Headcount Report options -->
	    <div class="uk-form uk-margin-medium-top" v-if="reportType == 'headcount'">
		    <div class="uk-margin-small">
			    <label>
				    In Business Unit
			    </label>
			    <select id="exp_burb" class="uk-select uk-width-auto" v-model="reportData.businessUnit">
				    <option value="">-- Select Business Unit --</option>
				    <option v-for="bu in businessUnits" :value="bu.id">{{ bu.name }}</option>
			    </select>
		    </div>
		    <div class="uk-margin-small">
			    <label>Report Date</label>
			    <datepicker ref="start_start_date" placeholder="Report Date" @input="startStartUpdated" :value="reportData.startStartDate" wrapper-class="inline" input-class="uk-input" :use-utc=true :clear-button=true :typeable=true clear-button-icon="fa fa-times" format="MM/dd/yyyy"></datepicker>
		    </div>
	    </div>
        <!-- Ratings Report options -->
        <div class="uk-form uk-margin-medium-top" v-if="reportType == 'ratings'">
            <div class="uk-form-label standard-text primary-color">Report Criteria</div>
            <div class="uk-margin-small">
                <label>
                    <input type="checkbox" class="uk-checkbox" v-model="reportData.useIncomplete">
                    That are
                </label>
                <label :disabled="!reportData.useIncomplete">
                    <input type="radio" name="drug_test_status" value="no" v-model="reportData.incomplete" :disabled="!reportData.useIncomplete" />
                    Completed
                </label>
                <label :disabled="!reportData.useIncomplete">
                    <input type="radio" name="drug_test_status" value="yes" v-model="reportData.incomplete" :disabled="!reportData.useIncomplete" />
                    Pending
                </label>
            </div>
            <div class="uk-margin-small">
                <label>
                    <input type="checkbox" class="uk-checkbox" v-model="reportData.useBusinessUnits">
                    In Business Unit
                </label>
                <select id="rep_bura" class="uk-select uk-width-auto" :disabled="!reportData.useBusinessUnits" v-model="reportData.businessUnit">
                    <option value="">-- Select Business Unit --</option>
                    <option v-for="bu in businessUnits" :value="bu.id">{{ bu.name }}</option>
                </select>
            </div>
            <div class="uk-margin-small">
                <label>
                    <input type="checkbox" class="uk-checkbox" v-model="reportData.useRequestedDateRange">
                    Requested between:
                </label>
                <datepicker ref="start_start_date" placeholder="Start Date" @input="requestedStartUpdated" :value="reportData.requestedStartDate" wrapper-class="inline" input-class="uk-input" :disabled="!reportData.useRequestedDateRange" :use-utc=true :clear-button=true :typeable=true clear-button-icon="fa fa-times" format="MM/dd/yyyy"></datepicker>
                <datepicker ref="start_end_date" placeholder="End Date" @input="requestedEndUpdated" :value="reportData.requestedEndDate" wrapper-class="inline" input-class="uk-input" :disabled="!reportData.useRequestedDateRange" :use-utc=true :clear-button=true :typeable=true clear-button-icon="fa fa-times" format="MM/dd/yyyy"></datepicker>
            </div>
            <div class="uk-margin-small">
                <label>
                    <input type="checkbox" class="uk-checkbox" v-model="reportData.useCompletedDateRange">
                    Completed between:
                </label>
                <datepicker ref="start_start_date" placeholder="Start Date" @input="completedStartUpdated" wrapper-class="inline" input-class="uk-input" :value="reportData.completedStartDate" :disabled="!reportData.useCompletedDateRange" :use-utc=true :clear-button=true :typeable=true clear-button-icon="fa fa-times" format="MM/dd/yyyy"></datepicker>
                <datepicker ref="start_end_date" placeholder="End Date" @input="completedEndUpdated" wrapper-class="inline" input-class="uk-input" :value="reportData.completedEndDate" :disabled="!reportData.useCompletedDateRange" :use-utc=true :clear-button=true :typeable=true clear-button-icon="fa fa-times" format="MM/dd/yyyy"></datepicker>
            </div>
        </div>
        <div class="uk-form uk-margin-medium-top" v-if="reportType == 'forecast'">
            <div class="uk-margin-small">
                <label>
                    Date Range:
                </label>
                <datepicker ref="start_start_date" placeholder="Start Date" @input="startUpdated" wrapper-class="inline" input-class="uk-input" :value="reportData.startDate" :use-utc=true :typeable=true format="MM/dd/yyyy"></datepicker>
                <datepicker ref="start_end_date" placeholder="End Date" @input="endUpdated" wrapper-class="inline" input-class="uk-input" :value="reportData.endDate" :use-utc=true :typeable=true format="MM/dd/yyyy"></datepicker>
            </div>
        </div>
        <!-- Expiring C/T -->
		<div class="uk-form uk-margin-medium-top" v-if="reportType == 'expiring'">
			<div class="uk-margin-small">
                <div class="uk-margin-small">
                    <label>
                        Expires Between:
                    </label>
                    <datepicker ref="start_start_date" placeholder="Start Date" @input="startUpdated" wrapper-class="inline" input-class="uk-input" :value="reportData.startDate" :use-utc=true :typeable=true format="MM/dd/yyyy"></datepicker>
                    <datepicker ref="start_end_date" placeholder="End Date" @input="endUpdated" wrapper-class="inline" input-class="uk-input" :value="reportData.endDate" :use-utc=true :typeable=true format="MM/dd/yyyy"></datepicker>
                </div>
			</div>
			<div class="uk-margin-small">
				<label>
					<input type="checkbox" class="uk-checkbox" v-model="reportData.useBusinessUnits">
					In Business Unit
				</label>
				<select id="exp_burb" class="uk-select uk-width-auto" :disabled="!reportData.useBusinessUnits" v-model="reportData.businessUnit">
					<option value="">-- Select Business Unit --</option>
					<option v-for="bu in businessUnits" :value="bu.id">{{ bu.name }}</option>
				</select>
			</div>
            <div class="uk-margin-small">
                <label>
                    <input type="checkbox" class="uk-checkbox" v-model="reportData.useCertification">
                    Certification
                </label>
                <select id="exp_certification" class="uk-select uk-width-auto" :disabled="!reportData.useCertification" v-model="reportData.certification">
                    <option value="">-- Select Certification --</option>
                    <option v-for="cert in certifications" :value="cert.id">{{ cert.name }}</option>
                </select>
            </div>
            <div class="uk-margin-small">
                <label>
                    <input type="checkbox" class="uk-checkbox" v-model="reportData.useTraining">
                    Training
                </label>
                <select id="exp_training" class="uk-select uk-width-auto" :disabled="!reportData.useTraining" v-model="reportData.training">
                    <option value="">-- Select Training --</option>
                    <option v-for="train in trainings" :value="train.id">{{ train.name }}</option>
                </select>
            </div>
		</div>

        <div class="divider thin uk-margin-medium-top"></div>
            <div class="uk-grid">
                <div class="uk-width-1-4@l uk-width-1-2">
                    <div class="uk-form-label standard-text primary-color uk-margin-small">Create Report Preset</div>
                    <input type="text" class="uk-input" v-model="reportName" placeholder="Create a report preset name" />
                </div>
                <div class="uk-width-1-4@l uk-width-1-2">
                    <div class="uk-form-label standard-text primary-color uk-margin-small">&nbsp;</div>
                    <button class="uk-button uk-button-primary" @click="saveReport">Save Report Preset</button>
                </div>
                <div class="uk-width-1-4@xl uk-width-1-2">
                    <div class="uk-grid">
                        <div class="uk-width-1-2">
                            <label class="uk-form-label">
                                <input type="checkbox" class="uk-checkbox" v-model="repeatMail">
                                Repeat Email
                            </label>
                        </div>
                        <div class="uk-width-1-2">
                            <label class="uk-form-label" style="display: block">
                                Interval
                            </label>
                            <select id="interval_type" class="uk-select uk-width-auto" :disabled="!repeatMail" v-model="intervalType">
                                <option value="">-- Select Interval --</option>
                                <option v-for="opt in intervalTypes" :value="opt.type">{{ opt.display }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="uk-width-1-4@xl uk-width-1-2" v-if="intervalType == 'weekly'">
                    <div class="uk-grid work-days">
                        <div class="uk-padding-small">
                            <label class="uk-form-label">
                                <div>Mon</div>
                                <input type="checkbox" name="work_mon" value="mon" class="uk-checkbox" v-model="reportDays">
                            </label>
                        </div>
                        <div class="uk-padding-small">
                            <label class="uk-form-label">
                                <div>Tue</div>
                                <input type="checkbox" name="work_tue" value="tue" class="uk-checkbox" v-model="reportDays">
                            </label>
                        </div>
                        <div class="uk-padding-small">
                            <label class="uk-form-label">
                                <div>Wed</div>
                                <input type="checkbox" name="work_wed" value="wed" class="uk-checkbox" v-model="reportDays">
                            </label>
                        </div>
                        <div class="uk-padding-small">
                            <label class="uk-form-label">
                                <div>Thu</div>
                                <input type="checkbox" name="work_thu" value="thu" class="uk-checkbox" v-model="reportDays">
                            </label>
                        </div>
                        <div class="uk-padding-small">
                            <label class="uk-form-label">
                                <div>Fri</div>
                                <input type="checkbox" name="work_fri" value="fri" class="uk-checkbox" v-model="reportDays">
                            </label>
                        </div>
                        <div class="uk-padding-small">
                            <label class="uk-form-label">
                                <div>Sat</div>
                                <input type="checkbox" name="work_sat" value="sat" class="uk-checkbox" v-model="reportDays">
                            </label>
                        </div>
                        <div class="uk-padding-small">
                            <label class="uk-form-label">
                                <div>Sun</div>
                                <input type="checkbox" name="work_sun" value="sun" class="uk-checkbox" v-model="reportDays">
                            </label>
                        </div>
                    </div>
                </div>
                <div class="uk-width-1-4@xl uk-width-1-2" v-if="intervalType == 'monthly'">
                    <label for="day_month" class="uk-form-label" style="display:block;">
                        Day of the month
                    </label>
                    <select id="day_month" class="uk-select uk-width-auto" v-model="reportDate">
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                        <option value="13">13</option>
                        <option value="14">14</option>
                        <option value="15">15</option>
                        <option value="16">16</option>
                        <option value="17">17</option>
                        <option value="18">18</option>
                        <option value="19">19</option>
                        <option value="20">20</option>
                        <option value="21">21</option>
                        <option value="22">22</option>
                        <option value="23">23</option>
                        <option value="24">24</option>
                        <option value="25">25</option>
                        <option value="26">26</option>
                        <option value="27">27</option>
                        <option value="28">28</option>
                    </select>
                </div>
            </div>

        <div class="divider thin uk-margin-medium-top"></div>
        <button class="uk-button uk-button-primary" @click="submitView">View Report <i class="fas fa-eye"></i></button>
        <div class="uk-margin-small"></div>
        <button class="uk-button uk-button-primary" @click="submitExport">Export Report <i class="fas fa-clipboard"></i></button>

        <form class="uk-hidden" ref="view_form" method="post" action="/report/view" target="_blank">
            <input type="hidden" name="_token" v-model="csrf" />
            <textarea name="data">{{ reportData }}</textarea>
        </form>
        <form class="uk-hidden" ref="export_form" method="post" action="/report/export" target="_blank">
            <input type="hidden" name="_token" v-model="csrf" />
            <textarea name="data">{{ reportData }}</textarea>
        </form>
        <form class="uk-hidden" ref="save_form" method="post" :action="saveLink">
            <input type="hidden" name="_token" v-model="csrf" />
            <textarea name="data">{{ reportData }}</textarea>
            <input type="hidden" name="name" v-model="reportName" />
            <input type="hidden" name="mail_report" v-model="repeatMail" />
            <input type="hidden" name="interval" v-model="intervalType" />
            <input type="hidden" name="days" v-model="daysResult" />
        </form>
    </div>
</template>

<script>
	import Datepicker from "vuejs-datepicker";
    export default {
        name: "ReportBuilder",

        components: {
			Datepicker
		},

        props: {
            csrf:{type:String},
            reportId:{type:String}
        },

        data() {
            return {
                reportData:{
                    type:"employee",
                    useRatings:false,
                    minRating: 0,
                    maxRating: 5,
                    useLocation: false,
                    state: "",
                    useCrafts:false,
                    craft:"",
                    useTraining:false,
                    training:"",
                    useCertifications:false,
                    certification:"",
                    useActive:false,
                    activity:"active",
                    useExpiring:false,
                    useDNH:true,
                    hireable:"yes",
                    useProbation: true,
                    probation:"off",
                    useBusinessUnits: false,
                    businessUnit: "",
                    useEverify: false,
                    useDrugTest: false,
                    drugTestStatus: "completed"
                },
                reportTypes: [
                    {
                        type:"employee",
                        display:"Employees"
                    },
                    {
                        type:"requisition",
                        display:"Requisitions"
                    },
                    {
                        type:"headcount",
                        display:"Head Count"
                    },
                    {
                        type:"ratings",
                        display:"Ratings"
                    },
                    {
                        type:"forecast",
                        display: "Forecast"
                    },
					{
						type: "expiring",
						display: "Expiring C/T"
					}
                ],
                reportType:"employee",
                states:{},
                crafts:{},
                trainings:{},
                certifications:{},
                businessUnits:{},
                reportName:"",
                repeatMail:false,
                intervalType:"",
                intervalTypes: [
                    {
                        type:"monthly",
                        display:"Every Month"
                    },
                    {
                        type:"weekly",
                        display:"Every Week"
                    },
                    {
                        type:"daily",
                        display:"Every Day"
                    },
                ],
                reportDays: [],
                reportDate: 1
            };
        },

        mounted() {
            axios.get("/api/forms/states").then(
                (pack) => this.updateStateList(pack)
            );
            axios.get("/api/training/list/all?sort=name&dir=asc").then(
                (pack) => this.updateTrainingList(pack)
            );
            axios.get("/api/certs/list/all?sort=name&dir=asc").then(
                (pack) => this.updateCertificationList(pack)
            );
            axios.get("/api/craft/list/all?sort=name&dir=asc").then(
                (pack) => this.updateCraftList(pack)
            );
            axios.get("/api/bu/list").then(
                (pack) => this.updateBusinessUnits(pack)
            );

            if(this.reportId !== ""){
                axios.get("/api/report/get/" + this.reportId).then(
                    (pack) => this.updateReport(pack)
                );
            }
        },

        methods: {
            updateReport(pack){
                if(pack.data.success){
                    let reportData = pack.data.data;
                    let repData = JSON.parse(reportData.data);

                    this.reportType = repData.type;

                    this.reportData = repData;

                    this.reportName = reportData.name;
                    this.repeatMail = reportData.mail_report == 1 || reportData.mail_report === true ? true:false;
                    this.intervalType = reportData.interval;

                    if(this.intervalType == "weekly"){
                        this.reportDays = reportData.days.split(",");
                    } else if(this.intervalType == "monthly"){
                        this.reportDate = reportData.days;
                    }
                }
            },
            updateStateList(pack) {
                if(pack.data.success){
                    this.states = pack.data.data;
                }
            },
            updateTrainingList(pack) {
                if(pack.data.success){
                    this.trainings = pack.data.data;
                }
            },
            updateCertificationList(pack) {
                if(pack.data.success){
                    this.certifications = pack.data.data;
                }
            },
            updateCraftList(pack) {
                if(pack.data.success){
                    this.crafts = pack.data.data;
                }
            },
            updateBusinessUnits(pack) {
                if(pack.data.success){
                    this.businessUnits = pack.data.data;
                }
            },
            startStartUpdated(date){
                this.reportData.startStartDate = date;
            },
            startEndUpdated(date){
                this.reportData.startEndDate = date;
            },
            endStartUpdated(date){
                this.reportData.endStartDate = date;
            },
            endEndUpdated(date){
                this.reportData.endEndDate = date;
            },
            requestedStartUpdated(date){
                this.reportData.requestedStartDate = date;
            },
            requestedEndUpdated(date){
                this.reportData.requestedEndDate = date;
            },
            completedStartUpdated(date){
                this.reportData.completedStartDate = date;
            },
            completedEndUpdated(date){
                this.reportData.completedEndDate = date;
            },
            startUpdated(date){
                this.reportData.startDate = date;
            },
            endUpdated(date){
                this.reportData.endDate = date;
            },
			certExpireUpdated(date){
				this.reportData.certExpireDate = date;
			},
			trainExpireUpdated(date){
				this.reportData.trainExpireDate = date;
			},
            submitView(){
				this.$forceUpdate();
				setTimeout(() => this.$refs.view_form.submit(), 5);
            },
            submitExport(){
				this.$forceUpdate();
				setTimeout(() => this.$refs.export_form.submit(), 5);
            },
            updateClearReportData(){
                switch(this.reportType){
                    case "employee":
                        this.reportData = {
                            type:"employee",
                            useRatings:false,
                            minRating: 0,
                            maxRating: 5,
                            useLocation: false,
                            state: "",
                            useCrafts:false,
                            craft:"",
                            useTraining:false,
                            training:"",
                            useCertifications:false,
                            certification:"",
                            useActive:false,
                            activity:"active",
                            useExpiring:false,
                            useDNH:true,
                            hireable:"yes",
                            useProbation: true,
                            probation:"off",
                            useBusinessUnits: false,
                            businessUnit: "",
                            useEverify: false,
                            useDrugTest: false,
                            drugTestStatus: "completed",
							certExpireDate: null,
							trainExpireDate: null,
                        };
                        break;
                    case "requisition":
                        this.reportData = {
                            type:"requisition",
                            useBusinessUnits: false,
                            businessUnit: "",
                            useLocation: false,
                            state: "",
                            useStartDateRange: false,
                            startStartDate: null,
                            startEndDate:null,
                            useEndDateRange: null,
                            endStartDate: null,
                            endEndDate:null,
                            useArchived:false
                        };
                        break;
	                case "headcount":
		                this.reportData = {
			                type:"headcount",
			                startStartDate: null,
			                businessUnit: "",
		                };
						setTimeout(() => {
							this.$refs.start_start_date.setDate(Date.now());
						}, 1);
		                break;
                    case "ratings":
                        this.reportData = {
                            type:"ratings",
                            useBusinessUnits: false,
                            businessUnit: "",
                            useIncomplete: false,
                            incomplete: "no",
                            useRequestedDateRange: false,
                            requestedStartDate: null,
                            requestedEndDate: null,
                            useCompletedDateRange: false,
                            completedStartDate: null,
                            completedEndDate: null,
                        };
                        break;
                    case "forecast":
                        let now = new Date();
                        let later = new Date();
                        later.setTime(later.getTime() + (90*24*60*60*1000));
                        this.reportData = {
                            type:"forecast",
                            startDate: now,
                            endDate: later
                        };
                        break;
                    case "expiring":
                        let now2 = new Date();
						let later2 = new Date();
						later2.setTime(later2.getTime() + (30*24*60*60*1000));
						this.reportData = {
							type:"expiring",
                            startDate: now2,
							endDate: later2,
							useBusinessUnits: false,
							businessUnit: "",
							useCertification: false,
							certification: "",
							useTraining: false,
							training: "",
						};
                    	break;
                }
            },
            saveReport(){
                if(this.reportName.trim() != ""){
                    this.$refs.save_form.submit();
                }
                else {
                    alert("Please enter a name for this report.");
                }
            }
        },
        computed:{
            daysResult(){
                if(this.intervalType == "weekly"){
                    return this.reportDays.join(",");
                } else if (this.intervalType == "monthly"){
                    return this.reportDate;
                }
                return "";
            },
            saveLink(){
                if(this.reportId != ""){
                    return "/report/save/" + this.reportId;
                }

                return "/report/save";
            }
        },
	    watch:{
			reportType(){
				this.updateClearReportData();
			}
	    }
    }
</script>
